import { CommonAPIService } from "@/serviceHandlers/CommonHandler";

export default class InsuranceProvidersAPIService {
  constructor() {
    this.commonAPIservice = new CommonAPIService();
  }

  getInsuranceProviderInfo(insuranceProviderId, router) {
    const url = `/api/insurance_providers/${insuranceProviderId}`;
    return this.commonAPIservice.getCall(url, "", router);
  }

  getInsuranceProviders(router) {
    const url = "/api/insurance_providers";
    return this.commonAPIservice.getCall(url, "", router);
  }

  createInsuranceProvider(params, router) {
    const url = "/api/insurance_providers";
    return this.commonAPIservice.postCall(url, params, router);
  }

  updateInsuranceProvider(insuranceProviderId, params, router) {
    const url = `/api/insurance_providers/${insuranceProviderId}`;
    return this.commonAPIservice.putCall(url, params, router);
  }

  deleteInsuranceProvider(insuranceProviderId, router) {
    const url = `/api/insurance_providers/${insuranceProviderId}`;
    return this.commonAPIservice.deleteCall(url, "", router);
  }
}
